import React from "react";
import { Box, Button, LoadingOverlay } from "@mantine/core";
import { IconPrinter } from "@tabler/icons-react";
import ReportHeader from "../../shell/ReportHeader";
import { COMPACT_BUTTON_PROPS } from "../compactButton";
import ReportHeaderActions from "../ReportHeaderActions";
import ReportToolbar from "../ReportToolbar";
import RunErrorPanel from "../RunErrorPanel";
import canvasStyles from "../ReportCanvas.module.css";
import SummaryLedgers from "./SummaryLedgers";
import { SummaryCanvasViewProps } from "./summaryCanvasTypes";
import styles from "./SummaryCanvas.module.css";

/**
 * The desktop layout of a summary report: header with Save view / Discard,
 * toolbar (date, filters, Print) and the ledgers. Renders the model
 * SummaryCanvas owns.
 */
export default function DesktopSummaryCanvas({
  canvas,
  definition,
  header,
  onDuplicate,
}: SummaryCanvasViewProps) {
  const { draft, view, run, data, settled } = canvas;
  return (
    <Box className={canvasStyles.page}>
      <ReportHeader
        {...header}
        duplicateLabel="Duplicate with this view"
        onDuplicate={onDuplicate}
        actions={
          <ReportHeaderActions
            dirty={draft.dirty}
            saving={draft.saving}
            onSave={() => void draft.save()}
            onDiscard={draft.discard}
            generatedAt={data?.generated_at}
            timezone={data?.timezone}
          />
        }
      />
      <ReportToolbar
        definition={definition}
        view={view}
        facets={run.data?.facets}
        resolvedRange={run.data?.date_range}
        hiddenFilters={canvas.hiddenFilters}
        onUpdate={draft.update}
        endSection={
          <Button
            {...COMPACT_BUTTON_PROPS}
            variant="default"
            leftSection={<IconPrinter size={14} aria-hidden />}
            onClick={canvas.printer.print}
            disabled={!settled}
          >
            Print
          </Button>
        }
      />
      <Box className={styles.body} data-empty={!run.data || undefined}>
        <LoadingOverlay visible={run.loading} zIndex={4} />
        {run.error ? (
          <RunErrorPanel error={run.error} onRetry={run.retry} />
        ) : (
          data && <SummaryLedgers name={header.name} data={data} />
        )}
      </Box>
    </Box>
  );
}
